import axios from 'axios'
import proj4 from 'proj4'

export async function loadEPSGDefinition(epsgCode: number) {
  const codeStr = `EPSG:${epsgCode}`

  if (proj4.defs(codeStr)) return

  const url = `https://epsg.io/${epsgCode}.proj4`
  const { data } = await axios.get<string>(url)
  const definition = data.trim()
  proj4.defs(codeStr, definition)
}
